"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const Button_1 = require("@Components/Buttons/Button");
const contexts_1 = require("@App/contexts");
const navigation_1 = __importDefault(require("@App/navigation"));
const rightsholder_contact_1 = require("@App/forms/rightsholder/rightsholder-contact");
const react_hook_form_1 = require("react-hook-form");
const InputTextForm_1 = __importDefault(require("@App/kit/fields/InputTextForm"));
const SubmitButton_1 = __importDefault(require("@App/kit/fields/SubmitButton"));
const react_router_dom_1 = require("react-router-dom");
const ContactNameTooltip_1 = __importDefault(require("@Components/RightsholderContact/RightsholderContactInformationEdit/ContactNameTooltip"));
const EmailAddressTooltip_1 = __importDefault(require("@Components/RightsholderContact/RightsholderContactInformationEdit/EmailAddressTooltip"));
const ContactAddressTooltip_1 = __importDefault(require("./ContactAddressTooltip"));
const MailingAddress_1 = __importDefault(require("@App/kit/fields/MailingAddress"));
const PhoneNumberForm_1 = __importDefault(require("@Fields/PhoneNumberForm"));
const mobx_react_1 = require("mobx-react");
const convert_empty_values_to_undefined_1 = __importDefault(require("@App/forms/v2/helpers/convert-empty-values-to-undefined"));
const ContactType_1 = __importDefault(require("./ContactType"));
const RightsholderContactInformationEdit = (props) => {
    const { preloaderStore, popupStore, contactStore, userStore, rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { createRightsholderContact, goBack } = props;
    const [contactFormFields] = (0, react_1.useState)((0, rightsholder_contact_1.createRightsholderContactFormFields)());
    const onSave = (data) => __awaiter(void 0, void 0, void 0, function* () {
        preloaderStore.openTransparentPreloader(true);
        data.address = (0, convert_empty_values_to_undefined_1.default)(data.address, true);
        data.phoneNumber = (0, convert_empty_values_to_undefined_1.default)(data.phoneNumber, true);
        if (createRightsholderContact) {
            try {
                yield contactStore.createRightsholderContact(data);
                popupStore.setAlertData('You successfully created a new Contact', false);
                navigate(navigation_1.default.rightholder.maintenance.memberContacts(rightsholderStore.currentRightsholderId));
            }
            catch (error) {
                popupStore.setAlertFromError(error);
            }
        }
        else {
            try {
                yield contactStore.editRightsholderContact(data);
                popupStore.setAlertData('Your Contact has been successfully updated', false);
                navigate(navigation_1.default.rightholder.maintenance.memberContacts(rightsholderStore.currentRightsholderId));
            }
            catch (error) {
                popupStore.setAlertFromError(error);
            }
        }
        preloaderStore.openTransparentPreloader(false);
    });
    const methods = (0, react_hook_form_1.useForm)({
        mode: 'onChange',
        criteriaMode: 'all',
        reValidateMode: 'onSubmit',
        delayError: 750, // MilliSeconds: this delay is here so email validation doesn't start when user starts typing
        defaultValues: contactStore.rightsholderContact || {
            rightsholderContactTypeId: null,
        },
    });
    (0, react_1.useEffect)(() => {
        if (!contactStore.rightsholderContacts) {
            contactStore.loadRightsholderContacts().then();
        }
    }, []);
    const title = createRightsholderContact ? 'Add Contact' : 'Edit Contact';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'contact-form-block' },
            react_1.default.createElement("div", { className: 'body-title' },
                react_1.default.createElement("h3", null, title)),
            react_1.default.createElement("div", { className: 'body-contact-info' },
                react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, methods),
                    react_1.default.createElement("form", { onSubmit: methods.handleSubmit(onSave) },
                        react_1.default.createElement("h5", { className: 'with-tooltip' },
                            "Contact Name",
                            react_1.default.createElement(ContactNameTooltip_1.default, null)),
                        react_1.default.createElement("div", { className: "contact-sub-section" },
                            react_1.default.createElement(InputTextForm_1.default, Object.assign({}, contactFormFields.firstName)),
                            react_1.default.createElement(InputTextForm_1.default, Object.assign({}, contactFormFields.lastName))),
                        react_1.default.createElement(ContactType_1.default, { rightsholderContactTypeId: contactFormFields.rightsholderContactTypeId }),
                        react_1.default.createElement("div", { className: 'with-tooltip' },
                            react_1.default.createElement(MailingAddress_1.default, { title: "Contact Address", toolTip: react_1.default.createElement(ContactAddressTooltip_1.default, null), mailingAddressFormProps: contactFormFields.address, optional: true })),
                        react_1.default.createElement("h5", { className: 'with-tooltip' },
                            "Contact Information",
                            react_1.default.createElement(EmailAddressTooltip_1.default, null)),
                        react_1.default.createElement("div", { className: "contact-sub-section contact-info-sub-section" },
                            react_1.default.createElement(PhoneNumberForm_1.default, { phoneNumberFormProps: contactFormFields.phoneNumber, optional: true }),
                            react_1.default.createElement(InputTextForm_1.default, Object.assign({}, contactFormFields.email))),
                        react_1.default.createElement("div", { className: 'buttons-block' },
                            react_1.default.createElement(Button_1.Button, { mainColor: false, type: 'primary', submitType: 'button', onClick: () => goBack() }, "Cancel"),
                            react_1.default.createElement(SubmitButton_1.default, { label: "Save", disabled: userStore.isInternal || !methods.formState.isValid }))))))));
};
exports.default = (0, mobx_react_1.observer)(RightsholderContactInformationEdit);
